export default {
  meta: {
    title: '规划详情',
    parentPath: ['/recommend/networkplan'],
    url: '/recommend/networkplanstatistic', // 埋点用，记录所属模块
    breadcrumbs: {
      path: ['/recommend/networkplan'],
      name: ['规划管理'],
      // noShow: true
    },
  },
};
